import { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import Section1 from '../../../components/SiteManagement/Form/MonthlyReport/Section1'
import Section2 from '../../../components/SiteManagement/Form/MonthlyReport/Section2'
import Section3 from '../../../components/SiteManagement/Form/MonthlyReport/Section3'
import Section4 from '../../../components/SiteManagement/Form/MonthlyReport/Section4'
import Section5 from '../../../components/SiteManagement/Form/MonthlyReport/Section5'
import Section6 from '../../../components/SiteManagement/Form/MonthlyReport/Section6'
import Section7 from '../../../components/SiteManagement/Form/MonthlyReport/Section7'
import Section8 from '../../../components/SiteManagement/Form/MonthlyReport/Section8'



import { v2_yards } from '../../../actions/v2/masterData';
import { v2_ships } from '../../../actions/v2/projectAndVessel';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { toast } from 'react-toastify';
import { v3_fetchMonthlyReportFormFields, v3_submitFatReportForm, v3_submitMonthlyReportForm } from '../../../actions/v3/siteManagement';
import Swal from 'sweetalert2';
import { v2_all_user } from '../../../actions/v2/user'

const MonthlyReport = (props) => {
    const location = useLocation();
    const { data } = location.state || {};
    const [commonDetails, setCommonDetails] = useState({
        ship: { value: '', options: [], error: '' },
        place: { value: '', error: '' },
        duration: { value: '', error: '' },
        finalSubmit: { value: false },
        yard: { value: '', options: [] },
        reportedBy: { value: '', options: [] }
    });

    const [formData, setFormData] = useState({
        on_schedule: { value: '', options: [], error: '' },
        minor_delay: { value: '', error: '' },
        affecting_delivery: { value: '', error: '' },
    });


    const [showLoader, setShowLoader] = useState(false);


    const [monthly_inspection_schedule_this_month, set_monthly_inspection_schedule_this_month] = useState([
        {
            inspection: { value: '' },
            result: { value: '' },
            feedback: { value: '' },
            evaluation: { value: '' },
        }
    ])
    const [monthly_inspection_schedule_following_month, set_monthly_inspection_schedule_following_month] = useState([
        {
            inspection: { value: '' },
            schedule: { value: '' },
        }
    ]);

    const [monthly_report_progress_schedule, set_monthly_report_progress_schedule] = useState([
        {
            steel_cutting: { value: '' },
            block: { value: '' },
            erection: { value: '' },
            hull_outfitting: { value: '' },
            paint: { value: '' },
            machine_fitting: { value: '' },
            electric: { value: '' },
            general: { value: '' },

        }
    ]);

    const [monthly_report_observations, set_monthly_report_observations] = useState([{
        observations: { value: '', error: '' }
    }])

    const [monthly_report_delay_reason, set_monthly_report_delay_reason] = useState([{
        reason_of_delay: { value: '', error: '' },
        count_measure: { value: '', error: '' },
        evaluation: { value: '', error: '' },
    }])

    const [monthly_report_inspection_comment, set_monthly_report_inspection_comment] = useState([
        {
            comment: { value: '', error: '' },
            reply: { value: '', error: '' },

        }
    ])

    const [monthly_report_field_comment, set_monthly_report_field_comment] = useState([{
        comment: { value: '', error: '' },
        reply: { value: '', error: '' },

    }])
    const [monthly_report_rejected_comment, set_monthly_report_rejected_comment] = useState([{
        comment: { value: '', error: '' },
        reason: { value: '', error: '' },

    }])

    const [monthly_report_fat_inspection, set_monthly_report_fat_inspection] = useState([{
        inspection: { value: '', error: '' },
        result: { value: '', error: '' },
        evaluation: { value: '', error: '' },
        feedback: { value: '', error: '' },
    }])


    const [monthly_report_hse_item, set_monthly_report_hse_item] = useState([{
        remark: { value: '', error: '' },
    }])

    const onSubmit = async () => {
        try {
            // 🔹 Collect Validation Errors
            const errors = [];
            if (!commonDetails.yard.value) errors.push("Select a yard.");
            if (!commonDetails.ship.value) errors.push("Select a ship.");
            if (!commonDetails.place.value) errors.push("Enter place.");
            if (!commonDetails.duration.value) errors.push("Enter duration.");

            if (errors.length > 0) {
                toast.error(errors.join("\n"));
                return;
            }

            // 🔹 Confirm Final Submit
            if (commonDetails.finalSubmit.value) {
                const confirmResult = await Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to submit the reports for Office Review?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, submit it",
                    cancelButtonText: "Cancel",
                });
                if (!confirmResult.isConfirmed) return;
            }

            // ✅ Common details
            const commonDetails_model = {
                yardId: commonDetails.yard.value,
                shipId: commonDetails.ship.value,
                duration: commonDetails.duration?.value || "",
                finalSubmit: commonDetails.finalSubmit.value,
                place: commonDetails.place.value,
                reportedBy: commonDetails.reportedBy.value
            };

            // ✅ Section models
            const formData_model = {
                on_schedule: formData.on_schedule.value,
                minor_delay: formData.minor_delay.value,
                affecting_delivery: formData.affecting_delivery.value,
            };

            const monthly_inspection_schedule_this_month_model =
                monthly_inspection_schedule_this_month.map((row) => ({
                    inspection: row.inspection.value,
                    result: row.result.value,
                    feedback: row.feedback.value,
                    evaluation: row.evaluation.value,
                }));

            const monthly_inspection_schedule_following_month_model =
                monthly_inspection_schedule_following_month.map((row) => ({
                    inspection: row.inspection.value,
                    schedule: row.schedule.value,
                }));

            const monthly_report_progress_schedule_model =
                monthly_report_progress_schedule.map((row) => ({
                    STEEL_CUTTING: row.steel_cutting.value,
                    BLOCK: row.block.value,
                    ERECTION: row.erection.value,
                    HULL_OUTFITTING: row.hull_outfitting.value,
                    PAINT: row.paint.value,
                    MACHINE_FITTING: row.machine_fitting.value,
                    ELECTRIC: row.electric.value,
                    GENERAL: row.general.value,
                }));

            const monthly_report_observations_model =
                monthly_report_observations.map((row) => ({
                    observations: row.observations.value,
                }));

            const monthly_report_delay_reason_model =
                monthly_report_delay_reason.map((row) => ({
                    reason_of_delay: row.reason_of_delay.value,
                    count_measure: row.count_measure.value,
                    evaluation: row.evaluation.value,
                }));

            const monthly_report_inspection_comment_model =
                monthly_report_inspection_comment.map((row) => ({
                    comment: row.comment.value,
                    reply: row.reply.value,
                }));

            const monthly_report_field_comment_model =
                monthly_report_field_comment.map((row) => ({
                    comment: row.comment.value,
                    reply: row.reply.value,
                }));

            const monthly_report_rejected_comment_model =
                monthly_report_rejected_comment.map((row) => ({
                    comment: row.comment.value,
                    reason: row.reason.value,
                }));

            const monthly_report_fat_inspection_model =
                monthly_report_fat_inspection.map((row) => ({
                    inspection: row.inspection.value,
                    result: row.result.value,
                    evaluation: row.evaluation.value,
                    feedback: row.feedback.value,
                }));

            const monthly_report_hse_item_model =
                monthly_report_hse_item.map((row) => ({
                    remark: row.remark.value,
                }));

            // ✅ Final Payload
            const payload = {
                commonDetails: commonDetails_model,
                formData: formData_model,
                monthly_inspection_schedule_this_month:
                    monthly_inspection_schedule_this_month_model,
                monthly_inspection_schedule_following_month:
                    monthly_inspection_schedule_following_month_model,
                monthly_report_progress_schedule:
                    monthly_report_progress_schedule_model,
                monthly_report_observations: monthly_report_observations_model,
                monthly_report_delay_reason: monthly_report_delay_reason_model,
                monthly_report_inspection_comment:
                    monthly_report_inspection_comment_model,
                monthly_report_field_comment: monthly_report_field_comment_model,
                monthly_report_rejected_comment:
                    monthly_report_rejected_comment_model,
                monthly_report_fat_inspection: monthly_report_fat_inspection_model,
                monthly_report_hse_item: monthly_report_hse_item_model,
            };

            // 🔹 Submit API
            setShowLoader(true);
            const response = await v3_submitMonthlyReportForm(payload);
            setShowLoader(false);

            if (response.status) {
                toast.success(response.result.message || "Submitted successfully!");
                props.history.push(constant.Authedcomponent.submittedMonthlyReport.url);
            } else {
                toast.error(response.error || "Submission failed.");
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Submit Error:", error);
            toast.error("Submission failed. Please try again.");
        }
    };

    // Load yards
    useEffect(() => {
        v2_yards().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    yard: { ...prev.yard, options: res.result },
                }));
            }
        });
        v2_all_user().then((res) => {
            if (res.status) {
                setCommonDetails((prev) => ({
                    ...prev,
                    reportedBy: { ...prev.reportedBy, options: res.result },
                }));
            }
        });
    }, []);

    // Load ships when yard changes
    useEffect(() => {
        if (commonDetails.yard.value) {
            v2_ships(null, null, commonDetails.yard.value).then((res) => {
                if (res.status) {
                    setCommonDetails((prev) => ({
                        ...prev,
                        ship: { ...prev.ship, options: res.result },
                    }));
                }
            });
        } else {
            setCommonDetails((prev) => ({
                ...prev,
                ship: { value: '', options: [] },
            }));
        }
    }, [commonDetails.yard.value]);

    useEffect(() => {
        const params = data ? JSON.parse(atob(data)) : null;

        if (params) {
            setShowLoader(true);

            v3_fetchMonthlyReportFormFields(params.FORM_ID)
                .then((res) => {
                    if (res.status) {
                        const {
                            commonDetails,
                            records,
                            monthly_inspection_schedule_following_month,
                            monthly_inspection_schedule_this_month,
                            monthly_report_fat_inspection,
                            monthly_report_hse_item,
                            monthly_report_observations,
                            monthly_report_progress_schedule,
                            monthly_report_rejected_comment,
                            monthly_report_delay_reason,
                            monthly_report_field_comment,
                            monthly_report_inspection_comment,
                        } = res.result;

                        // ✅ Prefill common details
                        setCommonDetails((prev) => ({
                            ...prev,
                            yard: { ...prev.yard, value: commonDetails?.YARD_ID || '' },
                            ship: { ...prev.ship, value: commonDetails?.SHIP_ID || '' },
                            place: { ...prev.place, value: commonDetails?.PLACE || '' },
                            duration: { ...prev.duration, value: commonDetails?.DURATION || '' },
                            finalSubmit: { ...prev.finalSubmit, value: Boolean(commonDetails?.FINAL_SUBMITTED) },
                        }));

                        // ✅ Prefill records
                        setFormData((prev) => ({
                            ...prev,
                            on_schedule: { ...prev.on_schedule, value: records?.PROGRESS_ON_SCHEDULE || '' },
                            minor_delay: { ...prev.minor_delay, value: records?.PROGRESS_MINOR_DELAY || '' },
                            affecting_delivery: { ...prev.affecting_delivery, value: records?.PROGRESS_AFFECTING_DELIVERY || '' },
                        }));

                        // ✅ Prefill child tables (similar to FAT)
                        set_monthly_inspection_schedule_following_month(monthly_inspection_schedule_following_month || []);
                        set_monthly_inspection_schedule_this_month(monthly_inspection_schedule_this_month || []);
                        set_monthly_report_fat_inspection(monthly_report_fat_inspection || []);
                        set_monthly_report_hse_item(monthly_report_hse_item || []);
                        set_monthly_report_observations(monthly_report_observations || []);
                        set_monthly_report_progress_schedule(monthly_report_progress_schedule || []);
                        set_monthly_report_rejected_comment(monthly_report_rejected_comment || []);
                        set_monthly_report_delay_reason(monthly_report_delay_reason || []);
                        set_monthly_report_field_comment(monthly_report_field_comment || []);
                        set_monthly_report_inspection_comment(monthly_report_inspection_comment || []);
                    } else {
                        toast.error(res.error || "Error fetching Monthly Report data");
                    }
                })
                .catch(() => {
                    toast.error("Something went wrong while fetching.");
                })
                .finally(() => {
                    setShowLoader(false);
                });
        }
    }, []);



    return (
        <Layout
            title={'FAT Report'}
        >
            <div className="row">
                <div className="col-lg-12">
                    <div className="card" id={1}>
                        <div className="card-body">
                            <div className="checklist-title-bx">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="text-center">
                                            <h4>Supervisor Report</h4>
                                            <p>
                                                Following to be checked and confirmed before official delivery
                                                of the vessel
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 ">
                                    <div className="report-index-top">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="hd-s2 w150">
                                                        <p>Shipyard</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                value={commonDetails.yard.value}
                                                                disabled={!!data}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        yard: { ...prev.yard, value: e.target.value },
                                                                    }))
                                                                }
                                                            >
                                                                <option value={""}>Select Shipyard</option>
                                                                {commonDetails.yard.options.map((item) => (
                                                                    <option key={item.ID} value={item.ID}>
                                                                        {item.YARD_NAME}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </td>

                                                    <td className="hd-s2 pl10 w150">
                                                        <p>Hull No</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                disabled={!!data}
                                                                value={commonDetails.ship.value}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        ship: { ...prev.ship, value: e.target.value },
                                                                    }))
                                                                }
                                                            >
                                                                <option value={""}>Select Hull</option>
                                                                {commonDetails.ship.options.map((item) => (
                                                                    <option key={item.ID} value={item.ID}>
                                                                        {item.HULL_NUMBER} - {item.SHIP_NAME}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="hd-s2 w150">
                                                        <p>Place</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Place"
                                                            value={commonDetails.place.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    place: { ...prev.place, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>

                                                    <td className="hd-s2 w150">
                                                        <p>Duration (in days)</p>
                                                    </td>
                                                    <td className="td-input-bx">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            placeholder="Duration"
                                                            value={commonDetails.duration.value}
                                                            onChange={(e) =>
                                                                setCommonDetails((prev) => ({
                                                                    ...prev,
                                                                    duration: { ...prev.duration, value: e.target.value },
                                                                }))
                                                            }
                                                        />
                                                    </td>

                                                    <td className="hd-s2 w150">
                                                        <p>Reported By</p>
                                                    </td>
                                                    <td className="td-input-bx" colSpan={3}>
                                                        <div className="hull-select-box">
                                                            <select
                                                                className="form-select"
                                                                disabled={!!data}
                                                                value={commonDetails.reportedBy.value}
                                                                onChange={(e) =>
                                                                    setCommonDetails((prev) => ({
                                                                        ...prev,
                                                                        reportedBy: { ...prev.reportedBy, value: e.target.value },
                                                                    }))
                                                                }
                                                            >
                                                                <option value={""}>Select User</option>
                                                                {commonDetails.reportedBy.options.map((item) => (
                                                                    <option key={item.USER_ID} value={item.USER_ID}>
                                                                        {item.FULL_NAME}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>

                                        </table>
                                    </div>

                                </div>
                            </div>
                            <Section1
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_inspection_schedule_this_month((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_inspection_schedule_this_month((prev) => [
                                        ...prev,
                                        {
                                            inspection: { value: '' },
                                            result: { value: '' },
                                            feedback: { value: '' },
                                            evaluation: { value: '' },
                                        },
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_inspection_schedule_this_month((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                state={monthly_inspection_schedule_this_month}
                            />
                            <Section2
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_inspection_schedule_following_month((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_inspection_schedule_following_month((prev) => [
                                        ...prev,
                                        {
                                            inspection: { value: '' },
                                            schedule: { value: '' },
                                        },
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_inspection_schedule_following_month((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                state={monthly_inspection_schedule_following_month}
                            />
                            <Section3
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_progress_schedule((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_report_progress_schedule((prev) => [
                                        ...prev,
                                        {
                                            steel_cutting: { value: '' },
                                            block: { value: '' },
                                            erection: { value: '' },
                                            hull_outfitting: { value: '' },
                                            paint: { value: '' },
                                            machine_fitting: { value: '' },
                                            electric: { value: '' },
                                            general: { value: '' },

                                        }
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_report_progress_schedule((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                onAddObservationsRow={() => {
                                    set_monthly_report_observations((prev) => [
                                        ...prev,
                                        {
                                            observations: { value: '' },
                                        }
                                    ]);
                                }}
                                onRemoveObservationsRow={(index) => {
                                    set_monthly_report_observations((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                state={monthly_report_progress_schedule}
                                formData={formData}
                                setFormData={setFormData}
                                monthly_report_observations={monthly_report_observations}
                                set_monthly_report_observations={set_monthly_report_observations}
                                monthly_report_delay_reason={monthly_report_delay_reason}
                                set_monthly_report_delay_reason={set_monthly_report_delay_reason}
                                onChange_monthly_report_observations={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_observations((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onChange_monthly_report_delay_reason={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_delay_reason((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddDelayReasonRow={() => {
                                    set_monthly_report_delay_reason((prev) => [
                                        ...prev,
                                        {
                                            reason_of_delay: { value: '', error: '' },
                                            count_measure: { value: '', error: '' },
                                            evaluation: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveDelayReasonRow={(index) => {
                                    set_monthly_report_delay_reason((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                            />
                            <Section4
                                onChangeInspectionComment={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_inspection_comment((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddInspectionCommentRow={() => {
                                    set_monthly_report_inspection_comment((prev) => [
                                        ...prev,
                                        {
                                            comment: { value: '', error: '' },
                                            reply: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveInspectionCommentRow={(index) => {
                                    set_monthly_report_inspection_comment((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                onChangeFieldComment={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_field_comment((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddFieldCommentRow={() => {
                                    set_monthly_report_field_comment((prev) => [
                                        ...prev,
                                        {
                                            comment: { value: '', error: '' },
                                            reply: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveFieldCommentRow={(index) => {
                                    set_monthly_report_field_comment((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                monthly_report_inspection_comment={monthly_report_inspection_comment}
                                monthly_report_field_comment={monthly_report_field_comment}

                            />
                            <Section5
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_fat_inspection((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_report_fat_inspection((prev) => [
                                        ...prev,
                                        {
                                            inspection: { value: '', error: '' },
                                            result: { value: '', error: '' },
                                            evaluation: { value: '', error: '' },
                                            feedback: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_report_fat_inspection((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                monthly_report_fat_inspection={monthly_report_fat_inspection}

                            />
                            <Section6
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_rejected_comment((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_report_rejected_comment((prev) => [
                                        ...prev,
                                        {
                                            comment: { value: '', error: '' },
                                            reason: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_report_rejected_comment((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                monthly_report_rejected_comment={monthly_report_rejected_comment}

                            />
                            <Section7
                                onChange={(e, index) => {
                                    const { name, value } = e.target;

                                    set_monthly_report_hse_item((prev) => {
                                        const updated = [...prev];
                                        updated[index] = {
                                            ...updated[index],
                                            [name]: { ...updated[index][name], value },
                                        };
                                        return updated;
                                    });
                                }}
                                onAddRow={() => {
                                    set_monthly_report_hse_item((prev) => [
                                        ...prev,
                                        {
                                            remark: { value: '', error: '' },
                                        }
                                    ]);
                                }}
                                onRemoveRow={(index) => {
                                    set_monthly_report_hse_item((prev) =>
                                        prev.filter((_, i) => i !== index)
                                    );
                                }}
                                monthly_report_hse_item={monthly_report_hse_item}


                            />

                            <div class="final-checkbox">
                                <div class="form-check">
                                    <input class="form-check-input" name="discountCheckbox" type="checkbox" checked={commonDetails.finalSubmit.value} onChange={() => setCommonDetails((prev) => ({
                                        ...prev,
                                        finalSubmit: { ...prev.finalSubmit, value: !commonDetails.finalSubmit.value },
                                    }))} id="productdiscountCheck1" />
                                    <label class="form-check-label" for="productdiscountCheck1">Send to Office for Review</label>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-lg-12 text-left ">
                                    <button

                                        className="btn btn-success"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                        onClick={() => {
                                            onSubmit()
                                        }}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="reset"
                                        className="btn btn-danger ms-3"
                                        style={{
                                            backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                            borderColor: "#2b5a7e"
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default MonthlyReport